import Vue from "vue";
import VueI18n from "vue-i18n";
// 全局挂载
Vue.use(VueI18n);

export const i18n = new VueI18n({
    // 从localStorage中获取 默认英文
    locale: localStorage.getItem("locale") || "en",
    messages: {
        en: require("./lan/en"),
        cn: require("./lan/cn")
    }
});

export default i18n;
